import * as React from "react";
import type { SVGProps } from "react";
const SvgCloud = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M17 20H6.5C4.02 20 2 17.98 2 15.5c0-1.75 1.02-3.31 2.54-4.05-.02-.15-.04-.3-.04-.45a3.009 3.009 0 0 1 3.65-2.93A5.002 5.002 0 0 1 12.5 5.5c2.6 0 4.74 1.99 4.98 4.52A5.002 5.002 0 0 1 17 20ZM7.5 10c-.55 0-1 .45-1 1 0 .19.05.37.16.53.18.28.2.63.07.93-.13.3-.4.52-.72.59A2.506 2.506 0 0 0 4 15.5 2.5 2.5 0 0 0 6.5 18H17c1.65 0 3-1.35 3-3s-1.35-3-3-3c-.12 0-.23.02-.35.04-.31.04-.66-.05-.88-.28-.22-.23-.36-.53-.32-.84.03-.19.05-.3.05-.42 0-1.65-1.35-3-3-3-1.34 0-2.49.87-2.86 2.17-.09.31-.33.56-.64.67-.31.1-.65.05-.91-.14a.978.978 0 0 0-.59-.2Z"
    />
  </svg>
);
export default SvgCloud;
